import React, { useState } from "react";
import PT_From from "./pt_From/PT_From";
import PT_table from "./pt_table/PT_table";

function PT() {
  const [showTable, setShowTable] = useState(false);

  return (
    <>
      <div className="imperiality_Form_div">
        <PT_From onProceed={() => setShowTable(true)} />
      </div>

      {showTable && (
        <div className="imperiality_table_div">
          <PT_table/>
        </div>
      )}
    </>
  );
}

export default PT;
